import React from 'react';
import { Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader, Media } from 'reactstrap';
import { Link } from 'react-router-dom';


function RenderLeader(props)
    { 
        if (props.leader!=null){
          
            return (
              <Media>
                  <Media left>
                    <img src={props.leader.image} alt={props.leader.name} />
                  </Media>
                  <Media body className="ml-5">
                    <Media heading>
                      {props.leader.name}
                    </Media>
                    <p>{props.leader.designation}</p>
                    <p>{props.leader.description}</p>
                  </Media>
            </Media>
            );
        }
        else{
            return <div></div>;
        };
};

function About(props) {

    const leaders = props.leaders.map((leader) => {
        return (
            <Media tag="li" key= {leader.id}>
                 <RenderLeader leader= {leader} />
             </Media>
        );
    });

    

    return(
        <div className="container">
            <div className="row">
                <Breadcrumb>
                    <BreadcrumbItem><Link to="/home">Home</Link></BreadcrumbItem>
                    <BreadcrumbItem active>About Us</BreadcrumbItem>
                </Breadcrumb>
                <div className="col-12">
                    <h3>About Us</h3>
                    <hr />
                </div>                
            </div>
            <div className="row row-content">
                <div className="col-12 col-md-6">
                    <h2>Our Books</h2>
                    <p>We wrote 5 books covering the life and chess of Bobby Fischer.</p>
                    <p>There are opening books which will give a player a complete repertoire.</p>
                    <p>There is a book on Strategy called "How Chessmasters Think".</p>
                    <p>There is a book on Tactics called "Chess Combinations of the World Champions".</p>
                </div>
                
                
            </div>
            <div className="row row-content">
                <div className="col-12">
                    <h2>Authors</h2>
                </div>
                <div className="col-12">
                    <Media list>
                        {leaders}
                    </Media>
                </div>
            </div>
        </div>
    );
}

export default About;    
